export default class StoreToppingGroupModel {
  groupCode;
  name;
  minCount;
  maxCount;

  constructor(data) {
    Object.assign(this, data);
  }
}
